import {html, css, LitElement, nothing} from 'lit';
import {ScopeBinding} from './behaviors/keli-binding-behavior.js';
import {SyncActionBrowseBehavior} from "./behaviors/sync-action-browse-behavior.js";
import '@shoelace-style/shoelace/dist/components/checkbox/checkbox.js';

class KeliMenuItem extends SyncActionBrowseBehavior(ScopeBinding(LitElement)) {
  static styles = css`
      :host {
          padding: 7px 15px 7px 15px;
          white-space: nowrap;
          display: block;
      }

      #handle {
          cursor: grab;
          font-size: 1.3em;
          vertical-align: middle;
      }

      #handle:active {
          cursor: grabbing;
      }

      #toggle {
          font-size: .9em;
      }

      sl-checkbox {
          white-space: normal;
      }

      #subtext {
          display: block;
          font-size: .8em;
          margin-left: 5px;
          margin-top: -1px;
          color: var(--keli-chrome-text-subtle-color);
      }

      :host(.disabled) {
          color: var(--keli-theme-grey-400) !important;
          background-color: transparent !important;
      }

      :host(.disabled) #subtext {
          color: var(--keli-theme-grey-400) !important;
      }
  `;

  static properties = {
    checked: {type: Boolean},
    caption: {type: String, scopeVar: true},
    enableUpdateEvents: {type: Boolean, attribute: 'enable-update-events'},
    subtext: {type: String},
    prefix: {type: String},
    keliname: {type: String},
    showHandle: {type: Boolean, attribute: 'show-handle'},
    showToggle: {type: Boolean, attribute: 'show-toggle'}
  };

  render() {
    const fullCaption = html`${this.prefix ? `${this.prefix}: ` : nothing}${this.caption || this.keliname || ''}`;
    return html`
        ${this.showHandle ? html`
            <sl-icon id="handle" name="drag"></sl-icon>` : nothing}
        ${this.showToggle ? html`
            <sl-checkbox id="toggle" checked="${(this.checked ? '' : nothing)}" @sl-change="${this.handleCheckboxChange}">
                ${fullCaption}
            </sl-checkbox>` : fullCaption}
        ${this.subtext ? html`<span id="subtext">${this.subtext}</span>` : nothing}
    `;
  }

  updated(changedProperties) {
    super.updated(changedProperties);

    for (const property of changedProperties.keys()) {
      if (this[`${property}Changed`]) {
        this[`${property}Changed`](this[property]);
      }
    }
  }

  captionChanged(newValue) {
    if (this.enableUpdateEvents) {
      this.dispatchEvent(new CustomEvent('keliMenuItemUpdated', {
        detail: {property: 'caption', value: newValue}
      }));
    }
  }

  disabledChanged(newValue) {
    this.classList.toggle('disabled', !!newValue);
  }

  handleCheckboxChange(event) {
    this.checked = event.target.checked;
    this.dispatchEvent(new CustomEvent('keli-menu-item-toggled', {
      detail: {keliname: this.keliname, toggle: event.target.checked}
    }));
  }
}

customElements.define('keli-menu-item', KeliMenuItem);
